module.exports = __webpack_public_path__ + "img/role.9ed75e4c.png";